// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".73c2e1b4baa5a39cd4fb6929c2565b11.js";
};